import {
    DataSourceMode, DataSourceModeChangeEvent, Label, LookupModelSearchEvent, LookupModelSelectionEvent, Panel,
    ValidationResult
} from "@mcleod/components";
import { Model, Navigation, StringUtil } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutOfficePayrollProfile } from "./autogen/AutogenLayoutOfficePayrollProfile";
import { BonusTaxUtils } from "../common/BonusTaxUtils";
import { DuplicateId } from "@mcleod/dispatch";

export class OfficePayrollProfile extends AutogenLayoutOfficePayrollProfile {
    onLoad(): void | Promise<void> {

        this.layoutProfileColor.profileDataSource = this.mainDataSource;
        this.sourceOfficePayrollProfile.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (event.newMode !== DataSourceMode.SEARCH) {
                this.setBonusTaxMethodVisibility();
            }
        });
        this.textboxBonusCode.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (this.sourceOfficePayrollProfile.mode !== DataSourceMode.SEARCH) {
                this.setBonusTaxMethodVisibility();
            }
        });
        this.textboxBonusCode.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter.is_active = "Y";
        });
        this.textboxBonusTaxMethod.addlValidationCallback = (value: string): ValidationResult => {
            const result: ValidationResult = {
                component: this.textboxBonusTaxMethod,
                isValid: true
            };
            if (this.textboxBonusTaxMethod.visible && StringUtil.isEmptyString(value)) {
                result.isValid = false;
                result.validationMessage = "Bonus Tax Method is required when a Bonus Code is selected.";
            }
            return result;
        };
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            return BonusTaxUtils.checkBonusTaxRates(this.activeRow);
        };
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "office_payroll_profile",
            screenName: "Office Payroll Profile",
            navigateToUrl: "lme/settlement/officepayroll/OfficePayrollProfile?mode=update&key="
        });
    }

    private async checkBonusTaxRates(): Promise<boolean> {
        const bonusTaxMethod = this.activeRow.get("bonus_tax_method");
        if (bonusTaxMethod !== "B") {
            return true;
        }
        let isValid = true;
        const panel = new Panel();
        const infoText = new Label({
            fontBold: true,
            text: "The Bonus Tax Rate is not set for the following tax tables, please update before saving this record:"
        });
        panel.add(infoText);
        const fedTaxTable = await Model.searchSingleRecord("lme/settlement/fedtaxtable");
        if (fedTaxTable == null || fedTaxTable.isNull("bonus_tax_rate")) {
            const fedTaxLabel = new Label({ text: "Update Federal Tax Table" });
            fedTaxLabel.applyLinkStyle();
            fedTaxLabel.addClickListener(() => {
                Navigation.navigateTo("lme/settlement/FederalTaxTable", { newTab: true });
            });
            panel.add(new Label({ text: "• ", rowBreak: false }));
            panel.add(fedTaxLabel);
            isValid = false;
        }
        const stateLocalTaxTables = await Model.search("lme/ar/statetax", { type_of: "S" });
        const stateLocalTaxTableIds = [];
        for (const taxTable of stateLocalTaxTables.modelRows) {
            if (taxTable.isNull("bonus_tax_rate")) {
                stateLocalTaxTableIds.push(taxTable.get("id"));
            }
        }
        if (stateLocalTaxTableIds.length > 0) {
            const stateTaxLabel = new Label({ text: "Update State Tax Tables" });
            stateTaxLabel.applyLinkStyle();
            stateTaxLabel.addClickListener(() => {
                Navigation.navigateTo("lme/settlement/StateTaxTableList?ids=" + encodeURIComponent(stateLocalTaxTableIds.join(",")), { newTab: true });
            });
            panel.add(new Label({ text: "• ", rowBreak: false }));
            panel.add(stateTaxLabel);
            isValid = false;
        }
        if (!isValid) {
            CommonDialogs.showDialog(panel, { title: "Error", width: 350 });
        }

        return isValid;
    }

    private setBonusTaxMethodVisibility() {
        const hasBonusCode = !StringUtil.isEmptyString(this.activeRow.get("bonus_code"));
        this.textboxBonusTaxMethod.visible = this.textboxBonusTaxMethod.required = hasBonusCode;
        if (!this.textboxBonusTaxMethod.visible) {
            this.textboxBonusTaxMethod.clear();
        }
    }
}
